import axios from 'axios'
export default class SignClient {
    constructor() {
        this.apiUrl = 'http://localhost:8089/PPSignSDK/';
        this.initUrl = this.apiUrl + 'InitialDevice?id=2&width=580&height=380';
        this.uninitUrl = this.apiUrl + 'UninitialDevice?id=2';
        this.getInkUrl = this.apiUrl + 'GetInks';
        this.clrInkUrl = this.apiUrl + 'Clear';
        this.isPolling = false
        this.initokCallback = null //设备初始化成功开始签字
        this.inkCallback = null; //读取到笔画图片信息
        this.errCallback = null //设备异常回调
    }
    initDevice() {
        axios({
            url: this.initUrl,
            type: 'GET',
            cache: false
        }).then((response) => {
            if (response && response.data === true) {
                this.isPolling = true;
                if(this.initokCallback){
                    this.initokCallback()
                }
                this.getInk();
            } else {
                if (this.errCallback) {
                    this.errCallback({ message: '未插入电子签名板' })
                }
            }
        }).catch((jqXHR, textStatus, errorThrown) => {
            if (this.errCallback) {
                this.errCallback({ message: '电子签名板驱动程序未启动' })
            }
        });
    }
    getInk() {
        const timeId = setTimeout(() => {
            clearTimeout(timeId);
            if (this.isPolling) {
                axios({
                    url: this.getInkUrl,
                    type: 'GET',
                    cache: false
                }).then((response) => {
                    //console.log('poll-getInkUrl');
                    var dataInfos = JSON.parse(response.data);
                    dataInfos.forEach((value) => {
                        if (value.EventType === 0) {
                            // drawImage(value.Image);
                            // LastSignatureBase64Data = value.Image;
                            let dataUrl = 'data:image/png;base64,';
                            dataUrl = dataUrl + value.Image;
                            if (this.inkCallback) {
                                this.inkCallback(dataUrl)
                            }
                        }
                    });
                }).finally(() => {
                    if (this.isPolling) {
                        this.getInk();
                    } else { }
                });
            }
        }, 50);
    }
    //清除
    clear() {
        axios({
            url: this.clrInkUrl,
            type: 'GET',
            cache: false,
            success: function success() {
                var canvas = document.getElementById('ppCanvas');

                context.clearRect(0, 0, canvas.width, canvas.height);
            }
        });
    }
    //设置画板初始化成功回调
    setInitokCallback(callback) {
        this.initokCallback = callback
    }
    //设置画板回调
    setInkCallback(callback) {
        this.inkCallback = callback
    }
    setErrCallback(callback) {
        this.errCallback = callback
    }
    //关闭服务
    close() {
        this.isPolling = false
        this.inkCallback = null
        this.errCallback = null
    }
}